import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { SegmentTrackEvent } from '@ninety/platform/models';
import { SegmentActions } from '@ninety/platform/state/app-global/analytics/segment/segment.actions';
import { ERROR_TRACKER, ErrorTracker } from '@ninety/ui/core';

/**
 * Binds the `ERROR_TRACKER` token consumed by `NotifyService` in `@ninety/ui/core` to the Segment
 * error-tracking dispatch. Inverting this lets `NotifyService` — and everything that transitively
 * depends on it (e.g. the avatar/logo upload dialogs) — be packaged in the public API without a direct
 * `@ninety/platform/state` dependency; this composition-root wiring is the single place that depends on
 * both the token and that platform lib. (DEV-26530 Part 8b)
 */
export const NOTIFY_PROVIDERS: Provider[] = [
  {
    provide: ERROR_TRACKER,
    useFactory:
      (store: Store): ErrorTracker =>
      (message, title) =>
        store.dispatch(
          SegmentActions.track({ event: SegmentTrackEvent.ERROR, params: { message, title, source: 'NotifyService' } })
        ),
    deps: [Store],
  },
];
